import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import {useSelector} from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useCreateScrapingCode = ({ onError, onSuccess}) => {
    
    const apiUrl = useSelector(apiUrlSelector);
    const queryClient = useQueryClient();

    return useMutation(values => {
        
            if ( parseInt(values.id) > 0 ) {
                return axios.patch(`${apiUrl}scrapping-codes/${values.id}`, values).then(res => res.data);
            } else {
                return axios.post(`${apiUrl}scrapping-codes`, values).then(res => res.data)
            }
        },
        {
            onSuccess: () => {
                onSuccess();
                queryClient.invalidateQueries(["scrapping-codes", apiUrl]);
            }, onError: onError
        }
    );
};

export default useCreateScrapingCode;